export const useCurrentPage = () => {
    const route = useRoute();
    return computed<number>(() => {
        const value = route.query?.page ? parseInt(route.query.page as string, 10) : 1;
        return isNaN(value) || value < 1 ? 1 : value;
    });
};
